import md from 'markdown-it';

const markdown = md({
  html: true,
  breaks: true,
  typographer: false,
});

function markdownToHtml(mdInput: string) {
  if (!mdInput) return null;
  return markdown.render(mdInput);
}

export default markdownToHtml;
